﻿﻿import { CannedResponseAvailability } from '../../enums/index';

export interface ITicketCannedResponse {
    id: number;
    title: string;
    message: string;
    availability: CannedResponseAvailability;
    ownerId: number;
    ownerName: string;
}
